"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _RadioAccordionItem = _interopRequireDefault(require("./components/RadioAccordionItem"));
var RadioAccordion = function RadioAccordion(props) {
  var initialActiveIndex = props.initialActiveIndex,
    children = props.children;
  var _React$useState = _react["default"].useState(initialActiveIndex),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    activeIndex = _React$useState2[0],
    setActiveIndex = _React$useState2[1];
  if (!children) {
    return null;
  }
  var childrenWithProps = _react["default"].Children.map(children, function (child, index) {
    var isActive = index === activeIndex;
    var clickHandler = function clickHandler() {
      return setActiveIndex(index);
    };
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      onClick: clickHandler,
      index: index,
      isActive: isActive
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, childrenWithProps);
};
RadioAccordion.Item = _RadioAccordionItem["default"];
var _default = exports["default"] = RadioAccordion;